import { apiCall } from 'helpers/api';

export const comments = (params = {}) => dispatch => {
    params.path = params.path || 'comments';
    return dispatch(apiCall(params));
}